<template>
  <div class="page-not-found under-construction">
    <main>
      <div class="container-xxl px-3">
        <div class="main__wrapper">
          <div class="content__wrapper">
            <div class="text-illustration">
              <div class="text">
                <div class="title">{{ content.title }}</div>
                <p class="lead-description">{{ content.description }}</p>

                <div class="access-section">
                  <h2 class="access-heading">{{ content.accessHeading }}</h2>
                  <p class="access-body">{{ content.accessBody }}</p>
                  <p class="access-note">{{ content.note }}</p>
                </div>

                <div class="legal-links">
                  <router-link to="/privacy-policy">
                    {{ content.privacyLinkLabel }}
                  </router-link>
                  <span class="separator" aria-hidden="true">|</span>
                  <router-link to="/terms-of-use">
                    {{ content.termsLinkLabel }}
                  </router-link>
                </div>
              </div>
              <div class="illustration">
                <img
                  src="./../assets/images/under-construction-illustration.svg"
                  alt="Digital Mortgage Application Portal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "Under-Construction",
  data() {
    return {
      content: {
        title: "Digital Mortgage Application Portal",
        description:
          "This secure online portal allows authorized users to submit and manage mortgage applications.",
        accessHeading: "Access by Invitation Only",
        accessBody:
          "A valid application link is required to access this portal. If you don't have a link, please contact your mortgage loan officer.",
        note: "If you received a link but are seeing this page, your invitation may have expired or the portal may be undergoing maintenance.",
        privacyLinkLabel: "Privacy Policy",
        termsLinkLabel: "Terms of Use",
      },
    };
  },
};
</script>

<style scoped>
@import "./../assets/css/under-construction.css";

.under-construction .lead-description {
  font-weight: 500;
}

.under-construction .illustration {
  display: flex;
  justify-content: center;
  align-items: center;
}

.under-construction .illustration img {
  width: 100%;
  max-width: 26rem;
  height: auto;
}

@media (min-width: 992px) {
  .under-construction .illustration img {
    max-width: 36rem;
  }
}

@media (min-width: 1200px) {
  .under-construction .illustration img {
    max-width: 44rem;
  }
}

@media (min-width: 1600px) {
  .under-construction .illustration img {
    max-width: 52rem;
  }
}

.under-construction .access-section {
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
}

.under-construction .access-section .access-heading {
  font-size: 1.25rem;
  line-height: 1.625rem;
  font-weight: 600;
  color: var(--color-black);
  margin-bottom: 0.5rem;
}

@media (min-width: 768px) {
  .under-construction .access-section .access-heading {
    font-size: 1.375rem;
    line-height: 1.75rem;
  }
}

.under-construction .access-section .access-body {
  margin-bottom: 0.75rem;
}

.under-construction .access-section .access-note {
  font-size: 0.9375rem;
  line-height: 1.375rem;
  color: #555;
  font-style: italic;
  margin-bottom: 0;
}

.under-construction .legal-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  margin-top: 1.5rem;
  font-size: 1rem;
}

.under-construction .legal-links a {
  color: var(--color-primary);
  text-decoration: underline;
  font-weight: 500;
}

.under-construction .legal-links a:hover,
.under-construction .legal-links a:focus {
  text-decoration: none;
}

.under-construction .legal-links .separator {
  color: #999;
}
</style>
